module.exports = __webpack_public_path__ + "static/media/filter.c1d2a0d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/filter.svg
// module id = 2998
// module chunks = 0